import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Drawer } from "@cinch-labs/design-system";
import styles from "./admin-fee.module.css";
export var AdminFee = function() {
    var ref = useState(false), isDrawerOpen = ref[0], setIsDrawerOpen = ref[1];
    var handleClick = function() {
        setIsDrawerOpen(true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: handleClick,
                className: styles.button,
                children: "Plus a \xa399 admin fee"
            }),
            isDrawerOpen && /*#__PURE__*/ _jsx(Drawer, {
                onClose: function() {
                    return setIsDrawerOpen(false);
                },
                header: "Admin Fee",
                ariaLabelledById: "admin-fee-drawer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.drawerContainer,
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.drawerText,
                            children: "The \xa399 admin fee powers your faff-free customer experience, including registration and administration costs associated with processing your car."
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: styles.drawerText,
                            children: "If you return your vehicle using our 14-day money-back guarantee, we’ll give you a full refund, including the \xa399 admin fee."
                        })
                    ]
                })
            })
        ]
    });
};
